import React, { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from './ui/dialog';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { carrierAPI } from '../api';
import { toastApiError } from '../lib/utils';

const EMPTY = { name: '', mc_number: '', dot_number: '', address: '', contact_phone: '', contact_email: '', equipment_types: [], regions_served: [] };

// Shared "Add New Carrier" dialog — used by the Carriers page and the load Carrier panel
export const CarrierFormDialog = ({ open, onOpenChange, onCreated, initial = {} }) => {
  const [carrier, setCarrier] = useState({ ...EMPTY, ...initial });
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (open) setCarrier({ ...EMPTY, ...initial }); }, [open]); // eslint-disable-line react-hooks/exhaustive-deps
  const upd = (field) => (e) => setCarrier(prev => ({ ...prev, [field]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const res = await carrierAPI.create(carrier);
      toast.success('Carrier created successfully');
      onCreated?.(res.data);
      onOpenChange(false);
    } catch (error) {
      toastApiError(toast, error, 'Carrier could not be created');
    } finally { setBusy(false); }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-h-[90vh] overflow-y-auto" data-testid="carrier-form-dialog">
        <DialogHeader><DialogTitle>Add New Carrier</DialogTitle></DialogHeader>
        <form onSubmit={submit} className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="cf-name">Carrier Name *</Label>
            <Input id="cf-name" value={carrier.name} onChange={upd('name')} required data-testid="input-carrier-name" data-field="name" />
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div className="space-y-2">
              <Label htmlFor="cf-mc">MC Number *</Label>
              <Input id="cf-mc" value={carrier.mc_number} onChange={upd('mc_number')} required data-testid="input-mc-number" data-field="mc_number" />
            </div>
            <div className="space-y-2">
              <Label htmlFor="cf-dot">DOT Number</Label>
              <Input id="cf-dot" value={carrier.dot_number} onChange={upd('dot_number')} data-testid="input-dot-number" />
            </div>
          </div>
          <div className="space-y-2">
            <Label htmlFor="cf-email">Email *</Label>
            <Input id="cf-email" type="email" value={carrier.contact_email} onChange={upd('contact_email')} required data-testid="input-email" data-field="contact_email" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="cf-phone">Phone *</Label>
            <Input id="cf-phone" value={carrier.contact_phone} onChange={upd('contact_phone')} required data-testid="input-phone" data-field="contact_phone" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="cf-address">Address *</Label>
            <Input id="cf-address" value={carrier.address} onChange={upd('address')} required data-testid="input-address" />
          </div>
          <div className="flex gap-2">
            <Button type="submit" disabled={busy} data-testid="submit-carrier-button">{busy ? 'Creating…' : 'Create Carrier'}</Button>
            <Button type="button" variant="outline" onClick={() => onOpenChange(false)}>Cancel</Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
};
